<template>
  <div
    class="form-group small-label inputStandard"
    :style="{'margin-bottom': error ? '.2rem' : '1.1rem'}"
  >
    <label v-if="value" :class="[disabled ? 'disabled' : '']" :for="name">{{ label }}</label>
    <input
      :type="type ? type : 'text'"
      class="form-control"
      :name="name"
      :id="name"
      v-model="value"
      :disabled="isDisabled"
      :aria-describedby="name"
      :placeholder="label"
    />
    <span class="inputStandard__moneySign">{{moneySign ? moneySign : ''}}</span>
    <span v-if="error" class="vv-error">{{ error }}</span>
  </div>
</template>

<script>
export default {
  props: ['label', 'name', 'error', 'type', 'disabled', 'valueFromParent', 'index', 'moneySign'],
  data() {
    return {
      value: ''
    };
  },
  mounted() {
    this.valueFromParent ? (this.value = this.valueFromParent) : false;
  },
  updated() {
    this.valueFromParent ? (this.value = this.valueFromParent) : false;
  },
  watch: {
    valueFromParent: function(newVal) {
      if (newVal) {
        this.value = newVal;
      }
    }
  },
  computed: {
    isDisabled() {
      return this.disabled;
    }
  },
  watch: {
    value(newVal) {
      if (this.index !== undefined) {
        this.$emit('changedValue', this.index, this.name, newVal);
      } else {
        this.$emit('changedValue', this.name, newVal);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.inputStandard {
  label.disabled {
    background: #e9ecef;
    border-radius: 20% 20%;
    margin-left: 0.8rem;
    padding: 0px 4px 0px 4px;
  }
  &__moneySign {
    position: absolute;
    top: 8px;
    right: 10px;
    font-size: 16px;
  }
}
</style>